/**
 * Status Filter Pills Component
 */
import React from 'react';
import { Tags, FileCheck, FileX, Clock, Timer } from 'lucide-react';

const filters = [
  { id: 'all', label: 'All', icon: Tags },
  { id: 'with-content', label: 'Content', icon: FileCheck },
  { id: 'empty', label: 'Empty', icon: FileX },
  { id: 'expired', label: 'Expired', icon: Timer },
  { id: 'recent', label: 'Recent', icon: Clock },
];

export const StatusFilters = ({
  activeFilter,
  onFilterChange,
  counts = {},
}) => {
  return (
    <div className="flex items-center gap-1 flex-wrap" data-testid="status-filters">
      {filters.map(({ id, label, icon: Icon }) => {
        const count = counts[id];
        const isActive = activeFilter === id;
        
        return (
          <button
            key={id}
            onClick={() => onFilterChange(id)}
            data-testid={`filter-${id}`}
            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium transition-all ${
              isActive
                ? id === 'expired' ? 'bg-orange-500 text-white' : 'bg-primary text-primary-foreground'
                : id === 'expired' && count > 0 ? 'bg-orange-100 text-orange-700 hover:bg-orange-200' : 'bg-secondary/50 text-muted-foreground hover:bg-secondary'
            }`}
          >
            <Icon className="w-3.5 h-3.5" />
            {label}
            {count !== undefined && (
              <span className={`text-xs ${isActive ? 'opacity-80' : 'opacity-60'}`}>
                ({count})
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default StatusFilters;
